/* Departures-board effects (owner brief header-departures-board.md).
 * Collection templates + hover-capable devices only: builds the
 * split-flap title strips, the count roll and the 4-tile preview stacks
 * from the JSON that main-collection-banner.liquid emits (real menu
 * labels, real counts), then drives everything through one --hd-idx
 * custom property. Guards: touch and no-JS get the static band and plain
 * title (this file simply does nothing); reduced motion is handled in
 * CSS. Nav cells stay plain <a>s throughout - hovering never intercepts
 * navigation.
 */
(function () {
  function init() {
    if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;
    var dataEl = document.querySelector('script[data-hd-board]');
    var nav = document.querySelector('.hd-nav');
    if (!dataEl || !nav) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var RED = '#E10600';
    var navCells = Array.prototype.slice.call(nav.querySelectorAll('.hd-cell--nav'));
    /* rows[0] = the current page; rows[i] pairs with navCells[i - 1]. */
    var rows = [{ label: data.current.title, line: data.current.line, red: false, images: [] }].concat(
      data.rows || []
    );
    if (navCells.length !== rows.length - 1) return;

    /* --- 1. split-flap title: one vertical strip per character position */
    var titleEl = document.querySelector('.collection-hero__title');
    if (titleEl) {
      var labels = rows.map(function (r) {
        return String(r.label || '').toUpperCase();
      });
      var maxLen = labels.reduce(function (m, l) {
        return Math.max(m, l.length);
      }, 0);
      var flip = document.createElement('span');
      flip.className = 'hd-flip';
      flip.setAttribute('aria-hidden', 'true');
      for (var s = 0; s < maxLen; s++) {
        var strip = document.createElement('span');
        strip.className = 'hd-flip__strip';
        strip.style.transitionDelay = 28 * s + 'ms';
        for (var r = 0; r < labels.length; r++) {
          var row = document.createElement('span');
          row.className = 'hd-flip__row';
          row.textContent = labels[r].charAt(s) || ' ';
          if (rows[r].red) row.style.color = RED;
          strip.appendChild(row);
        }
        flip.appendChild(strip);
      }
      var srTitle = document.createElement('span');
      srTitle.className = 'visually-hidden';
      srTitle.textContent = titleEl.textContent.replace(/\s+/g, ' ').trim();
      titleEl.textContent = '';
      titleEl.appendChild(srTitle);
      titleEl.appendChild(flip);
      titleEl.classList.add('hd-flip-host');
    }

    /* --- 2. count line roll */
    var countEl = document.querySelector('.collection-hero__count');
    if (countEl) {
      var roll = document.createElement('span');
      roll.className = 'hd-count';
      roll.setAttribute('aria-hidden', 'true');
      var cstrip = document.createElement('span');
      cstrip.className = 'hd-count__strip';
      cstrip.style.transitionDelay = '60ms';
      rows.forEach(function (r) {
        var line = document.createElement('span');
        line.className = 'hd-count__row';
        line.textContent = r.line || ' ';
        if (r.red) line.style.color = RED;
        cstrip.appendChild(line);
      });
      roll.appendChild(cstrip);
      var srCount = document.createElement('span');
      srCount.className = 'visually-hidden';
      srCount.textContent = countEl.textContent.replace(/\s+/g, ' ').trim();
      countEl.textContent = '';
      countEl.appendChild(srCount);
      countEl.appendChild(roll);
    }

    /* --- 3. preview stacks over the first 4 tiles. A row with no image
       for a tile (e.g. About) simply matches nothing, so the tile keeps
       the current collection's own card. */
    var tiles = Array.prototype.slice.call(
      document.querySelectorAll('#product-grid .grid__item .card__media'),
      0,
      4
    );
    var swaps = [];
    tiles.forEach(function (media, t) {
      var wrap = document.createElement('div');
      wrap.className = 'hd-swap';
      wrap.setAttribute('aria-hidden', 'true');
      var imgs = {};
      rows.forEach(function (r, i) {
        if (i === 0) return;
        var src = (r.images || [])[t];
        if (!src) return;
        var img = document.createElement('img');
        img.src = src;
        img.loading = 'lazy';
        img.alt = '';
        img.style.transitionDelay = 45 * t + 'ms';
        imgs[i] = img;
        wrap.appendChild(img);
      });
      media.appendChild(wrap);
      swaps.push(imgs);
    });

    /* --- 4. the index. JS only sets it; CSS does the rest. */
    var current = 0;
    function setIdx(i) {
      if (i === current) return;
      current = i;
      document.documentElement.style.setProperty('--hd-idx', i);
      swaps.forEach(function (imgs) {
        for (var k in imgs) imgs[k].classList.toggle('is-active', Number(k) === i);
      });
    }
    document.documentElement.style.setProperty('--hd-idx', 0);

    navCells.forEach(function (cell, n) {
      cell.addEventListener('mouseenter', function () {
        setIdx(n + 1);
      });
      cell.addEventListener('focusin', function () {
        setIdx(n + 1);
      });
    });
    nav.addEventListener('mouseleave', function () {
      setIdx(0);
    });
    nav.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!nav.contains(document.activeElement)) setIdx(0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
